import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import PropTypes, { InferProps } from 'prop-types';
import { ModalDrawer } from '../Drawer';
import Button from '../Button';
import ClearIcon from '../Icons/Clear';
import breakpoints from '../Theme/breakpoints';
import colors from '../Theme/colors';

const StyledDrawer = styled(ModalDrawer)`
  && {
    background-color: #f5f5f5;
    border: none;

    .MuiDrawer-paper {
      width: 100%;
      box-sizing: border-box;
      padding: 24px;
      display: ${(properties) => (properties.open ? 'block' : 'none')};

      @media (min-width: ${breakpoints.md}px) {
        display: flex;
        position: static;
        padding: 0;
        overflow: visible;
        background-color: #f5f5f5;
        border: none;
      }
    }
  }
`;

const InnerDrawer = styled.div`
  display: block;
  padding: 12px 24px;
  margin-bottom: 36px;
  @media (min-width: ${breakpoints.md}px) {
    order: 2;
    padding: 12px 0;
    margin-bottom: 0;
  }
`;

const ActionPanel = styled.div`
  width: calc(100% - 48px);
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 1;
  padding: 24px;
  overflow: visible;
  @media (min-width: ${breakpoints.md}px) {
    order: 1;
    position: static;
    background-color: #f5f5f5;
    padding: 0;
    width: auto;
  }
`;

const ActionPanelFade = styled.div`
  display: inline;
  pointer-events: none;
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  height: 24px;
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.8) 80%, rgba(255,255,255,1) 100%);
  @media (min-width: ${breakpoints.md}px) {
    display: none;
  }
`;

const filterButton = css`
  display: block;
  text-align: center;
  width: 100%;
  padding: 0px 15px 10px;
  .MuiButton-startIcon {
    display: inline-block;
    padding: 0 4px 0 0;
  }
  svg {
    position: relative;
    top: 6px;
    width: 24px;
  }
`;

export const ViewResultsButton = styled(Button)`
  ${filterButton}
  @media (min-width: ${breakpoints.md}px) {
    display: none;
  }
`;

const ClearResultsButton = styled(Button)`
  ${filterButton}
  &[disabled] {
    border-color: ${({ theme }) => theme.colors.greyLight};
  }
  @media (min-width: ${breakpoints.md}px) {
    margin-bottom: 8px;
    &[disabled] {
      display: none;
    }
  }
`;

const filterDrawerPropertyTypes = {
  children: PropTypes.node.isRequired,
  resultsButton: PropTypes.node.isRequired,
  clearResults: PropTypes.func.isRequired,
  filtersActivated: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  clearResultsMessage: PropTypes.string.isRequired,
};

type FilterDrawerProperties = InferProps<typeof filterDrawerPropertyTypes>;

const FilterDrawer = ({
  children,
  resultsButton,
  clearResults,
  filtersActivated,
  open,
  clearResultsMessage,
}: FilterDrawerProperties) => (
  <StyledDrawer
    open={open}
    variant="permanent"
    transitionDuration={0}
  >
    <InnerDrawer>
      {children}
    </InnerDrawer>
    <ActionPanel>
      <div>
        { resultsButton }
        <ClearResultsButton
          onClick={clearResults}
          className="clear-results"
          disabled={!filtersActivated}
          startIcon={(
            <ClearIcon
              fill={
                filtersActivated ? colors.primary : colors.greyLight
              }
            />
          )}
        >
          {clearResultsMessage}
        </ClearResultsButton>
      </div>
      <ActionPanelFade />
    </ActionPanel>
  </StyledDrawer>
);

FilterDrawer.propTypes = filterDrawerPropertyTypes;

export default FilterDrawer;
